<template>
  <div>
    Din Nexa Bridge uppdateras automatiskt varje gång en ny mjukvara finns tillgänglig så du kommer inte att behöva göra något. Just nu körs version <strong>{{ $root.data.info.version }}</strong> på din Bridge.
    
    <!--
    <div v-if="!updating">
      <div v-if="!updateAvailable">
        <h4>Ingen uppdatering tillgänglig</h4>
        <p>Just nu finns det ingen tillgänglig uppdatering för din Nexa Bridge, återkom om ett tag så kanske det finns något här. Du kommer alltid att behöva installera uppdateringarna manuellt.</p>
      </div>
      <div v-else>
        <h4>Uppdatering tillgänglig</h4>
        <p>Det <strong>finns</strong> en ny uppdatering tillgänglig för din Nexa Bridge. Versionsnummer {{ lastAvailableVersion }}, om du vill uppdatera till denna trycker du på knappen här nedanför. Processen kan ta upp till 10 minuter beroende på storlek och hastighet på internetuppkoppling.</p>
        <p>Din Bridge måste vara uppkopplad till internet under processen och du får inte dra ut strömmen under processen.</p>
        <hr class="space">
        <button @click="update">Uppdatera nu!</button>
      </div>
    </div>
    <div v-else>
      Uppdaterar...
    </div>
    -->
  </div>
</template>

<script>
  export default {
    name: 'installningar_uppdateringar',
    data: () => ({
      lastAvailableVersion: '7.12c7'
    }),
    created () {},
    methods: {},
    computed: {}
  }
</script>


// WEBPACK FOOTER //
// src/components/installningar_uppdateringar.vue